export default __webpack_public_path__ + "static/media/subscriptionempty.4137b2a6.svg";